
import Accordion from "../common/accordion/accordion.class.js";

// よくある質問の各項目をアコーディオン(クリックで開閉)にする
document.addEventListener( "DOMContentLoaded", () =>
{
    new Accordion( "p-faq-accordion", "p-faq-accordion__trigger", "p-faq-accordion__content", 300 );
}
);
